<template>
  <div class="picker">
    <div class="picker_box">
      <div class="picker_btns border-bottom">
        <span @click="closePicker">取消</span>
        <span @click="getPicker">确定</span>
      </div>
      <div
        class="picker_list"
        @touchstart="touchstart"
        @touchmove="touchmove"
        @touchend="touchend"
        ref="pickerUl"
      >
        <ul :style="{transform: 'translate3d(0,'+ transHeight +'px,0)'}">
          <li></li>
          <li></li>
          <li
            v-for="(item, index) in liList"
            :key="index"
            :class="{active:index==nowIndex}"
          >{{item.Name}}</li>
          <li></li>
          <li></li>
        </ul>
      </div>
      <div class="picker_line" ref="pickerLine"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    liList: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      liIndex: 0,
      liHeight: 1,
      transHeight: 0,
      nowIndex: 0
    };
  },
  methods: {
    touchstart() {
      this.liHeight = (
        this.$refs.pickerUl.children[0].offsetHeight /
        this.$refs.pickerUl.children[0].children.length
      ).toFixed(0);
    },
    touchmove() {
      let scrollLength = this.$refs.pickerUl.scrollTop;
      this.nowIndex = Number((scrollLength / this.liHeight).toFixed(0));
    },
    touchend() {
      let allHeight = this.nowIndex * this.liHeight;
      this.transHeight = this.$refs.pickerUl.scrollTop - allHeight;
    },
    closePicker() {
      this.$emit("closepicker");
    },
    getPicker() {
      this.liIndex = this.nowIndex;
      this.$emit("getPicker", this.liList[this.liIndex]);
    }
  }
};
</script>

<style lang="scss" scoped>
.picker {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 90;
  background-color: rgba(149, 165, 166, 0.5);
  .picker_box {
    width: 100%;
    height: 13rem;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 95;
    background: #ffffff;
    padding: 0.5rem;
    .picker_btns {
      width: 100%;
      height: 2rem;
      display: flex;
      justify-content: space-between;
      span {
        display: block;
        width: auto;
        height: 2rem;
        line-height: 2rem;
        padding: 0 0.5rem;
      }
    }
    .picker_list {
      width: 100%;
      height: 10rem;
      overflow: auto;
      position: relative;
      background-color: transparent;
      z-index: 80;
      ul {
        width: 100%;
        li {
          width: 100%;
          line-height: 2rem;
          height: 2rem;
          font-size: 1rem;
          transition: 0.5s;
          color: #999999;
          &.active {
            // font-weight: bold;
            letter-spacing: 0.1rem;
            font-size: 1.1rem;
            color: #e22519;
          }
        }
      }
    }
    .picker_line {
      width: 70%;
      height: 2rem;
      position: fixed;
      bottom: 4.5rem;
      left: 0;
      right: 0;
      margin: auto;
      z-index: 70;
      border-top: 1px solid #bdc3c7;
      border-bottom: 1px solid #bdc3c7;
    }
  }
}
</style>